import { render, staticRenderFns } from "./performance_sites_table.vue?vue&type=template&id=6b6cd3e1&"
import script from "./performance_sites_table.vue?vue&type=script&lang=js&"
export * from "./performance_sites_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports